import { useCallback } from 'react';

export const useOnSuccessfulInteraction = (handleOpenModal: () => void) => {
  const onSuccessfulInteraction = useCallback(() => {
    handleOpenModal();
  }, [handleOpenModal]);

  return onSuccessfulInteraction;
};
